import Vue from 'vue';
import Vuex from 'vuex';
import userStore from './modules/userStore/index';
import applicationStore from './modules/applicationStore/index';
import offlineStore from './modules/offlineStore/index';
import pointsStore from './modules/pointsStore/pointsStore';
import habitsDashboard from '../views/HabitsDashboard/store/habitsDashboard';
import gamefyStore from '../views/GamefyPage/store/gamefyStore';

Vue.use(Vuex);

export default new Vuex.Store(
  {
    state: {},
    modules: {
      offlineStore,
      userStore,
      applicationStore,
      pointsStore,
      habitsDashboard,
      gamefyStore,
    },
  },
);
